export interface ExpenseTypeOption {
  value: number
  label: string
}

export interface ExpenseTypeSuggestion {
  value: number | '__new__'
  label: string
  _isNew?: boolean
}

/**
 * Filter the option list by query (case-insensitive substring on label).
 * If `allowCreate` and the trimmed query is non-empty and no option's label
 * equals it exactly, append a synthetic "create" suggestion.
 */
export function buildExpenseTypeSuggestions(
  types: ExpenseTypeOption[],
  query: string,
  allowCreate = true,
): ExpenseTypeSuggestion[] {
  const q = query.toLowerCase().trim()
  const matches: ExpenseTypeSuggestion[] = types
    .filter(tp => tp.label.toLowerCase().includes(q))
    .map(tp => ({ value: tp.value, label: tp.label }))

  const exact = matches.some(m => m.label.toLowerCase() === q)
  if (allowCreate && q && !exact) {
    matches.push({ value: '__new__', label: query.trim(), _isNew: true })
  }
  return matches
}
